module.exports = __webpack_public_path__ + "img/slide1_9.2f925a52.png";